import Joi from 'joi';

export const useKnnValidationSchema = {
  useKnn: Joi.boolean(),
};
